import type { ResolverTag } from '@ps/web-core-enums';
import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';

import type { BaseProps } from './useOpenWindow';
import useOpenWindow from './useOpenWindow';

interface Options {
  query?: BaseProps['query'];
  openTab?: BaseProps['openTab'];
  centered?: BaseProps['centered'];
  resolverTag: ResolverTag;
}

export const useOpenDocumentVerification = ({ query, centered, resolverTag }: Options) => {
  const webTokenResolve = useFeature(FeatureFlag.SwcWebTokenResolve);

  const open = useOpenWindow({
    resolverTag,
    query,
    centered,
    webTokenResolve
  });

  return open;
};

export default useOpenDocumentVerification;
